// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_dz-2";
export var aiChatCartContainerExit = "_dz-4";
export var aiChatContainerLarge = "_dz-0";
export var aiChatContainerSmall = "_dz-1";
export var aiChatIcon = "_dz-6";
export var slideInFromRight = "_dz-3";
export var slideOutToRight = "_dz-5";